import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'
import { aiSlotExtraReducers } from '@store/reducres/aiSlot.reducers'
import { EntityId } from '@reduxjs/toolkit'

export const aiSlotUrl = 'slot/'

export interface AISlotModel extends DjangoModel {
  time?: Date | null
  name: string
  state: AiSlotState
  narrations: EntityId[]
  playlists: EntityId[]
  uploadTime: string | null
  plid: string
  station: string
  exactTime: string
  defaultVoice?: EntityId
  aiEntryMetadata?: EntityId
  bgAudio?: EntityId
  template?: EntityId
}

export enum AiSlotState {
  DONE = -1,
  PUBLISHED = 0,
  PARTIALLY_PUBLISHED = 1,
  AUDIO = 2,
  PARTIALLY_AUDIO = 3,
  TEXT = 4,
  OUTLINE = 5,
  NEW = 6,
}

const {
  slice: AiSlotSlice,
  thunks: AiSlotThunks,
  adapter: AiSlotAdapter,
  selectors,
  actions,
} = createGenericSlice<AISlotModel>('slot', aiSlotUrl, {}, aiSlotExtraReducers)

export const AiSlotAdapterExport = AiSlotAdapter

export const { selectById: selectAiSlotById } =
  AiSlotAdapter.getSelectors<RootState>((state: RootState) => state.slot)

export const { fetchById: fetchAiSlotById, fetchAll: fetchAllAiSlots } =
  AiSlotThunks
export const {
  selectLoading: selectAiSlotLoading,
  selectIsIdInProgress: selectIsAiSlotIdInProgress,
  selectError: selectSlotError,
  selectByIds: selectAiSlotsByIds,
} = selectors

export const {
  setInProgress: setAiSlotInProgress,
  setProgressFinished: setAiSlotProgressFinished,
} = actions

export default AiSlotSlice.reducer
